import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Disclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const disclaimerPoints = [
    {
      id: 1,
      title: "1. No Insurance Advice",
      content: "PolicySaath does not provide insurance advice, recommendations, or claim settlement services. All insurance decisions should be made by licensed insurance professionals.",
      icon: "bi-shield-exclamation"
    },
    {
      id: 2,
      title: "2. Accuracy of Information",
      content: "While we strive to keep information accurate and up to date, we make no guarantees about completeness, reliability, or accuracy.",
      icon: "bi-check-all"
    },
    {
      id: 3,
      title: "3. Third Party Links",
      content: "Our platform may contain links to third party websites. PolicySaath is not responsible for the content or practices of those sites.",
      icon: "bi-link-45deg"
    },
    {
      id: 4,
      title: "4. Business Risk",
      content: "Use of the software is at your own risk. PolicySaath is not liable for financial loss, missed renewals, commissions, or business outcomes.",
      icon: "bi-graph-down-arrow"
    },
    {
      id: 5,
      title: "5. Legal Compliance",
      content: "Users are solely responsible for complying with IRDAI regulations, data protection laws, and other applicable rules.",
      icon: "bi-graph-up-arrow"
    }
  ];

  return (
    <>
    <Header/>
    <div className="disclaimer-page">
      {/* Disclaimer Hero */}
      <section className="disclaimer-hero">
        <div className="container">
          <div className="hero-badge mt-5">Legal Notice</div>
          <h1>Disclaimer</h1>
          <p>Important information regarding the services and information provided by PolicySaath.</p>
        </div>
      </section>

      {/* Disclaimer Content */}
      <section className="disclaimer-body">
        <div className="container">
          <div className="intro-text-box">
            <p>
              The information and services provided on <strong>policysaath.com</strong> are for general information and software assistance purposes only.
            </p>
          </div>

          <div className="disclaimer-cards">
            {disclaimerPoints.map((item) => (
              <div key={item.id} className="disclaimer-card">
                <div className="card-icon">
                  <i className={`bi ${item.icon}`}></i>
                </div>
                <div className="card-content">
                  <h3>{item.title}</h3>
                  <p>{item.content}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="disclaimer-note">
            <p>
              <i className="bi bi-info-circle-fill"></i> By using our platform, you acknowledge that you have read and understood this disclaimer.
            </p>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
    </>
  );
};

export default Disclaimer;